module.exports = __webpack_public_path__ + "static/media/cancel-icon-signature.ad9002c0.svg";